<template>
  <div class="d-flex align-items-center h-100">
    <b-card class="mx-auto loginFormCard" header-tag="header" footer-tag="footer">
      <h5 slot="header" class="mb-0" align="center">Вход в систему</h5>
      <b-form
        @submit.prevent="onSubmit"
      >
        <b-form-group
          label="Почта"
          label-for="emailInput"
          description="Введите почту, с которой вы были зарегистрированы в данной системе."
        >
          <b-form-input
            id="emailInput"
            v-model="form.login"
            type="email"
            required
            placeholder="Введите почту"
          ></b-form-input>
        </b-form-group>

        <b-form-group label="Пароль" label-for="passwordInput">
          <b-form-input
            id="passwordInput"
            v-model="form.password"
            type="password"
            required
            placeholder="Введите пароль"
          ></b-form-input>
        </b-form-group>
        <div>
          <b-form-checkbox
            v-model="form.saveMe"
            class="float-left" style="display: inline-block"
          >
            Запомнить меня?
          </b-form-checkbox>
          <div id="buttonDiv" align="right">
            <b-button
              type="submit"
              variant="outline-primary"
              align="center"
              class="loginFormCard__loginButton"
            >
              <em class="fas fa-sign-in" aria-hidden="true"></em> Войти
            </b-button>
          </div>
        </div>
      </b-form>
      <template #footer>
        <div align="center">
          <b-link to='/recover'>Забыли пароль или не можете войти?</b-link>
        </div>
      </template>
    </b-card>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'LoginForm',
  data() {
    return {
      form: {
        login: '',
        password: '',
        saveMe: false
      }
    }
  },
  mounted() {
    this.fetchLink()
  },
  methods: {
    onSubmit() {
      this.signIn(this.form).then(() => {
        if (!this.error) {
          const { redirect } = this.$route.query
          window.location = redirect || this.appLink
        } else {
          this.pushToasts({
            title: 'Уведомление',
            error: true,
            message: 'Неправильный адрес электронной почты или пароль!',
            time: 15
          })
        }
      })
    },
    ...mapActions({
      signIn: 'currentUser/signIn',
      pushToasts: 'toasts/pushToasts',
      fetchLink: 'dicts/fetchLink'
    })
  },
  computed: {
    ...mapGetters({
      error: 'currentUser/getError',
      appLink: 'dicts/getLink'
    })
  }
}
</script>

<style scoped>
  .card-header{
    background-color: #017ac3;
    color: white;
  }

  .card{
    width: 60vw;
    max-width: 900px;
  }

  .loginFormCard__loginButton {
    float: right;
  }

  @media only screen and (max-width: 768px) {
    .card{
      width: 90vw;
    }
  }

  @media only screen and (max-width: 480px) {
    .loginFormCard__loginButton {
      width: 100%;
      margin-top: 10px;
    }
  }
</style>
